import 'lightgallery.js/dist/css/lightgallery.css';

if (typeof window !== 'undefined') {
	require(['lightgallery.js'], function() {
		const galleries = document.querySelectorAll('.js-gallery');

		[].forEach.call(galleries, gallery => {
			lightGallery(gallery, {
				mode: 'lg-fade',
				download: false,
				subHtmlSelectorRelative: true
			});
		});
	});
}


// WEBPACK FOOTER //
// ./src/components/gallery/gallery.js